(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ms-lang').forEach(function (wrap) {
      var trigger = wrap.querySelector('.ms-lang__trigger');
      var list = wrap.querySelector('.ms-lang__list');
      var select = wrap.parentElement.querySelector('select[name="language_code"]');
      var current = wrap.querySelector('[ref="msLangCurrent"]');

      trigger.addEventListener('click', function () {
        var isOpen = !list.hidden;
        list.hidden = isOpen;
        trigger.setAttribute('aria-expanded', String(!isOpen));
      });

      wrap.querySelectorAll('.ms-lang__item').forEach(function (item) {
        item.addEventListener('click', function () {
          var iso = item.getAttribute('data-iso');
          select.value = iso;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          wrap.querySelectorAll('.ms-lang__item').forEach(function (i) { i.classList.remove('is-selected'); });
          item.classList.add('is-selected');
          current.textContent = item.textContent.trim();
          list.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        });
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          list.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
